import { render, staticRenderFns } from "./Snowflake.vue?vue&type=template&id=d9f65472&"
import script from "./Snowflake.vue?vue&type=script&lang=js&"
export * from "./Snowflake.vue?vue&type=script&lang=js&"
import style0 from "./Snowflake.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports